<template>
  <div class="common-body">
    <a :href="adAddress" alt="101游戏" target="_blank" :style="{backgroundImage: 'url('+this.adUrl+')'}" class="common-logo"></a>
    <div class="common-content">
        <img src="../../assets/image/information_icon_normal.png" class="common-content-image">
        <ul class="information-header-ul">
          <li v-for="(item,index) in informationTabList"  :key="index" :class="index == selectDirector ? 'information-header-li-active':''" class="information-header-li"
              @click="selectInformation(item.id)">
              {{item.name}}
          </li> 
      </ul>
    </div>
    <div class="information-item" v-for="(item,index) in informationList" :key="index" @click="enterInformationDetails(item.information_id)">
      <span class="information-item-type">{{getInformationType(item.information_type)}}</span>
      <div class="information-item-content">
        <p class="information-item-p" style="font-size: 16px;color: #505050;"><span style="margin-right: 20px;">{{new Date(item.information_time).Format("MM-dd hh:mm")}}</span>{{item.information_title}}</p>
        <p class="information-item-p"><span style="margin-right: 20px;">发布人:101游戏小编</span><span>关键词:{{item.information_keyword}}</span></p>
      </div>
      <img class="information-item-image" src="../../assets/image/information_enter_normal.png">
    </div>
    <CommonPage v-if="showPageState" class="information-page" :current.sync='informationBean.page'
     :page-size="informationBean.row" :total="informationTotal" show-total  show-elevator  @on-change="selectPage" prev-text="上一页" next-text="下一页"/>
  </div>
</template>

<script>
  import CommonPage from '../../components/CommonPage';
  export default {
    metaInfo(){
      return {
        title:"资讯列表_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    components:{ CommonPage },
    computed:{
      showPageState:{
        get(){
          return this.$store.state.informationList.showPageState;
        } ,set(value){
          this.$store.state.informationList.showPageState = value;
        }  
      },
      informationList:{
        get(){
          return this.$store.state.informationList.informationList;
        },set(value){
          this.$store.state.informationList.informationList = value;
        }
      },
      informationTotal:{
        get(){
          return this.$store.state.informationList.informationTotal;
        },set(value){
          this.$store.state.informationList.informationTotal = value;
        } 
      },
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      }
    },
    asyncData({store,route}){
      return store.dispatch('initInformationList',{gid:route.query.gid,store:store});
    },
    data(){
      return{
        adAddress:"",
        adUrl:"",
        gameTag:"",
        selectDirector:0,
        informationTabList:[
          {id:0,name:"综合"},
          {id:1,name:"新闻"},
          {id:2,name:"公告"},
          {id:3,name:"活动"},
          {id:6,name:"攻略"},
        ],
        informationBean:{
          gid: 0,
          type: 0,
          page: 1,
          row: 10
        }
      }
    },
    methods:{ 
      queryAdData(){
        this.$http.get(`/query_web_ad?type=5`,{})
        .then(res=>{
          if(res.data.code == 2000){
            this.adAddress = res.data.data[0].ad_address;
            this.adUrl = this.baseAddress+res.data.data[0].ad_url;
          }else{
            this.adAddress = "";
            this.adUrl = "";
          }
        });
      },
      selectInformation(value){
        this.selectDirector = value;
        this.informationBean.type = value;
        this.queryGameInformation();
      },
      enterInformationDetails(value){
        window.open(this.$router.resolve({name:'informationDetails',query:{news_id:value}}).href,'_blank');
      },
      queryGameInformation(){
        this.informationBean.game_tag = this.$route.query.game_tag;
        this.$http.get(`/query_web_news_list`, { params: this.informationBean })
          .then(res => {
            if (res.data.code == 2000 && res.data.data.length != 0) {
              this.informationList = res.data.data;
              this.informationTotal = res.data.total;
              if(this.informationTotal <10){
                this.showPageState = false;
              }else{
                this.showPageState = true;
              }
            }else{
              this.informationList=[]
            }
        });
      },
      selectPage(value){
        this.informationBean.page = value;
        this.queryGameInformation();
      },
      getInformationType(value){
        switch(value){
          case 1:
            return "新闻";
          case 2:
            return "公告";
          case 3:
            return "活动";
          case 6:
            return "攻略";
        }
      }
    },
    mounted(){
      this.gameTag = this.$route.query.game_tag;
      this.queryGameInformation();
      this.queryAdData();
    }
  }

</script>
<style src="@/assets/css/information/information_list.css" scoped></style>